import React from "react";
import { Control, Controller } from "react-hook-form";
import { FormSection } from "./FormSection";
import { Field, Input, Textarea } from "@/components/ui";
import { FormSchemaType } from "../FormEditView";

interface IntroSectionProps {
  control: Control<FormSchemaType>;
}

export function IntroSection({ control }: IntroSectionProps) {
  return (
    <FormSection id="section-intro" title="Intro Section">
      <div className="flex flex-col gap-4">
        <Controller
          name="introTitle"
          control={control}
          render={({ field, fieldState }) => (
            <Field label="Intro Title" name="introTitle" error={fieldState.error?.message}>
              <Input {...field} maxLength={255} placeholder="e.g. Welcome to our survey!" />
            </Field>
          )}
        />
        <Controller
          name="introText"
          control={control}
          render={({ field, fieldState }) => (
            <Field label="Intro Text" name="introText" error={fieldState.error?.message}>
              <Textarea {...field} placeholder="e.g. Please take a few moments to fill out this form." />
            </Field>
          )}
        />
      </div>
    </FormSection>
  );
}
